<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center justify-center>
        <v-flex>
          <div id="firebaseui-auth-container"></div>
        </v-flex>       
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import firebase from 'firebase'
import firebaseui from 'firebaseui'
export default{
  name: 'Login',
  mounted() {
    var uiConfig = {
      signInSuccessUrl: '/',
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
        ]
      };
    let ui = firebaseui.auth.AuthUI.getInstance();
    if(!ui){
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }
    ui.start('#firebaseui-auth-container', uiConfig);
  },
  methods: {
    login(){
      
    }
  }
}

</script>

<style scoped>
a{
  text-decoration: none;
}

</style>
